import classNames from "clsx";

import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { useWindowDimensions } from "@/hooks/useWindowDimensions";

import { PatientInformationCards } from "@/components/PatientInformationCards";

export function Attendance() {
	const { width } = useWindowDimensions();

	return (
		<>
			<Row>
				<Col md={9} className={classNames(width <= 820 && "mb-6")}>
					{/* Portal */}
					<Card
						id="attendance-content"
						className="overflow-y-scroll overflow-x-hidden h-85vh"
					></Card>
				</Col>

				<Col md={3}>
					<PatientInformationCards />
				</Col>
			</Row>
		</>
	);
}
